<vectronic-filter-header
  [title]="title()"
  (titleClicked)="toggled.emit()"
  (enabledFilterToggle)="toggled.emit()"
  [isFilterEnabled]="expanded()"
></vectronic-filter-header>
<div [hidden]="!expanded()">
  <mat-radio-group
    class="d-flex flex-column gap-8"
    [value]="value()?.mode"
    (change)="onModeChange($event)"
  >
    @if (!options()?.modes || options()?.modes?.includes('utc')) {
      <!-- 1. Time Span [UTC] -->
      <mat-radio-button value="utc" color="primary"> Time Span [UTC] </mat-radio-button>

      @if (currentValue().mode === 'utc') {
        <vectronic-datepicker
          label="From"
          type="startOfDay"
          [value]="currentValue().start"
          [max]="currentValue().end"
          (dateChange)="onDatePickerChange('start', $event, 'utc')"
        ></vectronic-datepicker>

        <vectronic-datepicker
          label="To"
          type="endOfDay"
          [value]="currentValue().end"
          [min]="currentValue().start"
          (dateChange)="onDatePickerChange('end', $event, 'utc')"
        ></vectronic-datepicker>
      }
    }

    <!-- 2. Time Span [LMT] -->
    @if (
      (!options()?.modes || options()?.modes?.includes('lmt')) && timeService.shouldShowLocalTime()
    ) {
      <mat-radio-button value="lmt" color="primary"> Time Span [LMT] </mat-radio-button>

      @if (currentValue().mode === 'lmt') {
        <vectronic-datepicker
          label="From"
          type="startOfDay"
          [useLMT]="true"
          [value]="currentValue().start"
          [max]="currentValue().end"
          (dateChange)="onDatePickerChange('start', $event, 'lmt')"
        ></vectronic-datepicker>

        <vectronic-datepicker
          label="To"
          type="endOfDay"
          [useLMT]="true"
          [value]="currentValue().end"
          [min]="currentValue().start"
          (dateChange)="onDatePickerChange('end', $event, 'lmt')"
        ></vectronic-datepicker>
      }
    }

    <!-- 3. Recent -->
    @if (!options()?.modes || options()?.modes?.includes('recent')) {
      <mat-radio-button value="recent" color="primary"> Recent </mat-radio-button>

      @if (currentValue().mode === 'recent') {
        <div class="d-flex">
          <mat-form-field appearance="outline" style="width: 120px">
            <input
              matInput
              type="number"
              min="1"
              (input)="onRecentValueChange($event)"
              (change)="$event.stopPropagation()"
              [value]="currentValue().recent?.value"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label>Unit</mat-label>
            <mat-select
              [value]="currentValue().recent?.unit"
              (selectionChange)="onRecentUnitChange($event)"
            >
              <mat-option value="h">Hours</mat-option>
              <mat-option value="d">Days</mat-option>
              <mat-option value="w">Weeks</mat-option>
              <mat-option value="M">Months</mat-option>
              <mat-option value="y">Years</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
    }
  </mat-radio-group>
</div>
